import { format, isSameDay, parse } from "date-fns";
import React from "react";
import { useParams } from "react-router-dom";
import Event from "./Event";
import Weather from "./Weather";
import getLocationSlug, { legend, wakefieldLegend } from "./utils/getLocationSlug";
import getStartAndEndDate from "./utils/getStartAndEndDate";
import useSheets from "./utils/useSheets";

export default function LocationView(props) {
  const { events, today } = useSheets({ view: "today" });
  const match = useParams<{ wing?: string; community: string }>();
  const locationSlug = props.location || match.wing;
  let communityLegend = legend;

  // console.log("today", today);
  // console.log("events", events);

  if (match.community === "wakefield" || match.community === "apex") {
    communityLegend = wakefieldLegend;
  }

  const location = communityLegend[locationSlug]?.label;
  let extraEvents = [];

  if (props.location && (location === "C Wing" || location === "B Wing")) {
    const extraEventsData = useSheets({
      view: "today",
      location: props.location,
    });

    extraEvents = extraEventsData.events;
  }

  // console.log("location", location);

  let title = location && `Today in ${location}`;

  if (locationSlug === "c-wing") {
    title = "Today in Memory Care — C Wing";
  } else if (locationSlug === "b-wing" && match.community !== "fuquay") {
    title = "Today in Memory Care — B Wing";
  }

  if (communityLegend[locationSlug].rooms.includes(location)) {
    title = `Today in ${communityLegend[locationSlug]?.label}`;
  }

  let map = "/img/map.png";

  if (locationSlug) {
    if (match.community === "fuquay") {
      map = `/img/fuquay-${locationSlug}.png`;
    } else if (match.community === "wakefield") {
      map = `/img/wakefield-${locationSlug}.jpg`;
    } else if (match.community === "apex") {
      map = `/img/apex-${locationSlug}.jpg`;
    } else {
      map = `/img/map-${locationSlug}.png`;
    }
  }

  const locationEvents = [...events, ...extraEvents]
    .reduce((acc, e) => {
      const slug = `${e["Event-Name"]}-${e["Event-Location"]}-${e["Event-Date"]}`;
      const existing = acc.find((a) => {
        const aSlug = `${a["Event-Name"]}-${a["Event-Location"]}-${a["Event-Date"]}`;
        return aSlug === slug;
      });

      if (existing) {
        return acc;
      }

      acc.push(e);

      return acc;
    }, [])
    .filter((e) => {
      const eventDate = parse(e["Event-Date"], "M/d/yy", new Date());
      const eventLocationSlug = getLocationSlug(e["Event-Location"]?.trim(), match.community);

      // if (e["Event-Location"] === "Main Dining Room") {
      //   console.log("eventDate", eventDate);
      //   console.log("locationSlug", locationSlug);
      //   console.log("eventLocationSlug", eventLocationSlug);
      // }

      return (
        isSameDay(eventDate, today) &&
        e["Event-Name"] !== "Move In" &&
        (locationSlug === eventLocationSlug ||
          communityLegend[locationSlug].rooms.includes(e["Event-Location"]))
      );
    })
    .sort((a, b) => {
      const { startDate: startDateA } = getStartAndEndDate(a);
      const { startDate: startDateB } = getStartAndEndDate(b);

      return startDateA.getTime() - startDateB.getTime();
    })
    .map((e, i) => {
      return (
        <React.Fragment key={i}>
          <Event event={e} type="today" community={match.community} />
        </React.Fragment>
      );
    });

  return (
    <React.Fragment>
      <header className="header header--week">
        <div className="header__logo">
          <img src={`/img/logo-stacked.png`} alt="logo" />
        </div>
        <h1 className="header__title">
          {format(today, "EEEE, MMMM d")}{" "}
          <span className="header__title-date">{format(today, "h:mm aaaa")}</span>
        </h1>
        <div className="header__weather">
          <Weather />
        </div>
      </header>
      <header className="header header--no-bg">
        <h1 className="header__title">{title}</h1>
      </header>
      <div className="calendar-container">
        <div className="table table--today table--location">
          <div className="thead">
            <div className="th th--times">Times</div>
            <div className="th th--activities">Activities</div>
            <div className="th th--location">Location</div>
          </div>
          <div className="tbody">{locationEvents}</div>
          <div className="map__meta">All times subject to change.</div>
        </div>
        <div className="map" style={{ backgroundImage: `url(${map})` }}></div>
      </div>
    </React.Fragment>
  );
}
